import { Translate } from 'next-translate';

const Factory = (t: Translate): Map<string, string> =>
  new Map([
    ['AD_DURATION', ''],
    ['AD_PROGRESS', ''],
    ['AD_TIME', ''],
    ['AUTO_QUALITY', t('auto_quality')],
    ['BACK', t('back')],
    ['CAPTIONS', t('captions')],
    ['CAST', t('cast_to_other_devices')],
    ['ENTER_LOOP_MODE', ''],
    ['ENTER_PICTURE_IN_PICTURE', t('enter_picture_in_picture')],
    ['EXIT_FULL_SCREEN', t('exit_fullscreen')],
    ['EXIT_LOOP_MODE', ''],
    ['EXIT_PICTURE_IN_PICTURE', t('exit_picture_in_picture')],
    ['FAST_FORWARD', ''],
    ['FULL_SCREEN', t('fullscreen')],
    ['LANGUAGE', t('language')],
    ['LIVE', t('live')],
    ['LOOP', ''],
    ['MORE_SETTINGS', t('more_settings')],
    ['MULTIPLE_LANGUAGES', t('multiple_languages')],
    ['MUTE', t('mute')],
    ['NOT_APPLICABLE', t('not_applicable')],
    ['OFF', t('off')],
    ['ON', t('on')],
    ['PAUSE', t('pause')],
    ['PICTURE_IN_PICTURE', t('picture_in_picture')],
    ['PLAY', t('play')],
    ['PLAYBACK_RATE', ''],
    ['RESOLUTION', t('resolution')],
    ['REWIND', ''],
    ['SEEK', t('seek')],
    ['SKIP_AD', ''],
    ['SKIP_TO_LIVE', ''],
    ['UNDETERMINED_LANGUAGE', t('undetermined_language')],
    ['UNMUTE', t('unmute')],
    ['UNRECOGNIZED_LANGUAGE', t('undetermined_language')],
    ['VOLUME', t('volume')],
  ]);

export default Factory;
